document.addEventListener("DOMContentLoaded", () => {
  const footer = document.getElementById("stickyCartFooter");
  const toggleBtn = document.getElementById("toggleStickyCart");
  const cta = document.getElementById("freeGiftCta");
  const alert = document.getElementById("stickyCartAlert");
  const viewCartMain = document.querySelector(".sticky-cart-footer__main");
  const itemCount = document.getElementById("cartItemCount");
  const shippingBar = document.getElementById("shippingBar");
  const barFill = document.getElementById("shippingBarFill");
  const barText = document.getElementById("shippingBarText");
  const cartSummaryBtn = document.getElementById("cartSummary");


    // -----------------------------  
    // FREE GIFT RULES (CONFIG)
    // -----------------------------
    //
    // Each rule = one potential free gift.
    // The engine will:
    // - Check if it's eligible based on minPaddles / minSubtotal / quantity
    // - Check if it has already been claimed
    // - Show the FIRST eligible + unclaimed rule as a gift panel
    // - Use its options[] to build the thumbnails + labels
    //
    // You can reorder / add / remove rules to change behavior.

     // GIFT 1
    const FREE_BLACKOUT_COVER = 48700858630437;
    const FREE_VICE_COVER = 51520717160741;
    const FREE_SUNSET_COVER = 51520738394405;

    // Legacy gift that might still appear in some carts
    const FREE_PICKLE_DAD_HAT = 50556494610725;

    // GIFT 2
    const FREE_SOCKS_SMALL = 51630405878053;
    const FREE_SOCKS_LARGE = 51630406009125;
    const FREE_OVERGRIP = 51630406238501;

    // GIFT 3
    const FREE_ROPE_HAT_WHITE = 51630676017445;
    const FREE_BALLS_3PACK = 51630687846693;
    const FREE_ATHLETIC_HAT = 51630675886373;

    const FREE_GIFT_RULES = [
    // {
    //     id: "gift4_sunset_noir_over_200",
    //     priority: 1,
    //     // NEW: subtotal-based gift
    //     minPaddles: 0,           // no paddle requirement
    //     minSubtotal: 200,        // unlocked at $100 subtotal (same as free ship)
    //     minQuantity: null,
    //     quantityFilter: null,
    //     excludedVariants: [],
    //     // We'll resolve this variant from variantMap so you don't need the raw ID
    //     claimedVariantIds: [51672540709157, 51672540774693],   // we fill at runtime once we have the ID
    //     options: [
    //     { variantId: 51672540709157, label: "Sunset Noir Original" },
    //     { variantId: 51672540774693, label: "Vice Original" }
    //     ],
    // },
    {
        id: "gift1_covers",
        priority: 2,
        // CONDITIONS
        minPaddles: 1,          // unlocked at 2+ paddles
        minSubtotal: null,      // no spend requirement
        minQuantity: null,      // optional – see notes below
        quantityFilter: null,   // optional – function(cartItem) => boolean
        excludedVariants: [],   // optional – excluded from quantity calc

        // CLAIMED WHEN any of these variants are in the cart at $0
        claimedVariantIds: [FREE_VICE_COVER, FREE_SUNSET_COVER],

        // UI / VARIANTS TO CHOOSE FROM
        options: [
        { variantId: FREE_SUNSET_COVER, label: "SUNSET COVER" },
        { variantId: FREE_VICE_COVER, label: "VICE COVER" },
        ],
    },
    // {
    //     id: "gift2_softgoods",
    //     priority: 3,
    //     minPaddles: 2,
    //     minSubtotal: null,
    //     minQuantity: null,
    //     quantityFilter: null,
    //     excludedVariants: [],
    //     claimedVariantIds: [
    //       51630405878053, 
    //       FREE_SOCKS_LARGE, 
    //       // 51719018053925
    //     ],
    //     options: [
    //     { variantId: 51630405878053, label: "RED/BLUE SOCKS (SMALL)" },
    //     { variantId: FREE_SOCKS_LARGE, label: "RED/BLUE SOCKS (LARGE)" },
    //     // { variantId: 51719018053925, label: "RAW CARBON PADDLE CLEANER" },
    //     ],
    // },
    // {
    //     id: "gift3_hat_or_balls",
    //     priority: 4,
    //     minPaddles: 3,
    //     minSubtotal: null,
    //     minQuantity: null,
    //     quantityFilter: null,
    //     excludedVariants: [],
    //     claimedVariantIds: [FREE_ROPE_HAT_WHITE, FREE_BALLS_3PACK, FREE_ATHLETIC_HAT],
    //     options: [
    //     { variantId: FREE_ROPE_HAT_WHITE, label: "WHITE ROPE HAT" },
    //     { variantId: FREE_BALLS_3PACK, label: "3-PACK BALLS" },
    //     { variantId: FREE_ATHLETIC_HAT, label: "WHITE ATHLETIC HAT" },
    //     ],
    // }
    ];
    // Build a flat list of *all* free-gift variant IDs for summary / item-count logic
    let freeGiftArray = [FREE_PICKLE_DAD_HAT];
    FREE_GIFT_RULES.forEach((rule) => {
        if (Array.isArray(rule.claimedVariantIds)) {
            freeGiftArray.push(...rule.claimedVariantIds);
        }
    });


  // -----------------------------
  // UPSSELL CONFIG
  // -----------------------------
  // Each object can have:
  // - variantId (number) OR resolveVariantId(): () => number | null
  // - title (string)
  // - badge (string)         // red text above
  // - price (number|null)    // sale price
  // - compareAt (number|null)// strikethrough price
  // - buttonText (string)    // defaults to "Add to Cart"
  //
  // You can add / remove / edit these without touching the main logic.

  const RAW_UPSELL_ITEMS = [
    {
      variantId: 49967881027877,
      resolveVariantId: () => {
        const covers = window.variantMap?.["friday-challenger-paddle"] || {};
        return covers["Cardinal"]?.id || null;
      },
      title: "Cardinal Challenger",
      badge: "25% OFF",
      price: 67,
      compareAt: 89,
      buttonText: "Add to Cart",
    },
    {
      variantId: 51557297455397,
      title: "Accessories Kit",
      badge: "37% OFF",
      price: 25,
      compareAt: 40,
      buttonText: "Add to Cart",
    },
    {
      variantId: 51101112697125,
      title: "Pickleball 9-Pack",
      badge: "10% OFF",
      price: 26, // infer from variant if left null
      compareAt: 29,
      buttonText: "Add Balls",
    },
  ];

  const FREE_SHIPPING_THRESHOLD = 100; // Black Friday free shipping threshold in dollars

  const FREE_GIFT_PRODUCT_ID = 9300911522085; // legacy, not used for tiers but kept for safety
  const PADDLE_COVER_PRODUCT = 8939807047973;
  const BACKPACK_HANDLE = "friday-pickleball-equipment-backpack";
  const BACKPACK_PRODUCT = 9682547605797;
  const SET_PRODUCT_ID = 9443483910437;
  const COVER_HASH = "#paddle-covers";
  const VALID_COVERS = ["Sunset", "Dawn"];

  const SUMMER_HEAT = 48953189204261;
  const SEA_SALT = window.variantMap["friday-paddle"]["Sea Salt"].id;
  const GOLDEN_HOUR = window.variantMap["friday-paddle"]["Golden Hour"].id;

  const DOORBUSTER_PRODUCT_IDS = [10237442392357];

  let hasClickedCoverUpsell = false;
  let isInView = false;
  let currentCart = null;
  let isCollapsed = false;
  let hasUnclaimedGift = false;

  const selector =
    '[data-pcplink="product-section"], [data-show-sticky-footer="true"]';
  const anchorVisibility = new Map();
  let observer;

  // --- Intersection observer for "bundle in view" ---

  function initStickyAnchors() {
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          anchorVisibility.set(entry.target, entry.isIntersecting);
        });

        isInView = Array.from(anchorVisibility.values()).some(Boolean);
        updateStickyFooter(currentCart || { items: [] });
      });
    }

    document.querySelectorAll(selector).forEach((el) => {
      if (!anchorVisibility.has(el)) {
        anchorVisibility.set(el, false);
        observer.observe(el);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initStickyAnchors);
  window.addEventListener("load", initStickyAnchors);
  setTimeout(initStickyAnchors, 1000);

  // --- Toggle "Hide Offer" / "Show Offer" / "Claim Gift" label ---

  function updateToggleLabel() {
    if (!toggleBtn) return;
    let label;
    if (isCollapsed) {
      label = hasUnclaimedGift ? "Claim Gift" : "Show Offer";
    } else {
      label = "Hide Offer";
    }
    toggleBtn.textContent = label;
    toggleBtn.setAttribute("aria-label", label);
  }

  function updateCollapseState(collapsed) {
    isCollapsed = collapsed;
    if (!footer) return;
    footer.setAttribute("data-collapsed", collapsed ? "true" : "false");
    if (toggleBtn) {
      toggleBtn.setAttribute("aria-expanded", collapsed ? "false" : "true");
    }
    if (
      window.stickyCartA11y &&
      typeof window.stickyCartA11y.setCollapsed === "function"
    ) {
      window.stickyCartA11y.setCollapsed(collapsed);
    }
    updateToggleLabel();
  }

  toggleBtn?.addEventListener("click", () => {
    const nowCollapsed = !isCollapsed;
    updateCollapseState(nowCollapsed);
  });

  // -----------------------------
  // HELPERS
  // -----------------------------

  function getVariantById(variantId) {
    for (const product of Object.values(window.variantMap || {})) {
      for (const variant of Object.values(product)) {
        if (variant.id === variantId) return variant;
      }
    }
    return null;
  }


  function getImageUrlForVariant(variantId) {
    for (const product of Object.values(window.variantMap || {})) {
      for (const variant of Object.values(product)) {
        if (variant.id === variantId) return variant.image;
      }
    }
    return null;
  }

  function getAvailability(variantId) {
    for (const product of Object.values(window.variantMap || {})) {
      for (const variant of Object.values(product)) {
        if (variant.id === variantId) return variant.available;
      }
    }
    return null;
  }

  function isTierClaimed(cart, tierArray) {
    if (!cart?.items || !tierArray?.length) return false;
    return cart.items.some(
      (item) => tierArray.includes(item.variant_id) && item.discounted_price === 0
    );
  }

  function shouldFooterBeVisible(cart) {
    const totalItems =
      cart?.items?.reduce((sum, item) => sum + item.quantity, 0) || 0;
    return isInView && totalItems > 0;
  }

  function getPaddleQuantity(cart) {
    return cart.items.reduce((total, item) => {
      const type = item.product_type?.toLowerCase();
      const title = item.title || "";
      if (item.product_id === SET_PRODUCT_ID) {
        if (title.includes("/")) {
          return total + ((title.match(/\//g) || []).length + 1) * item.quantity;
        } else if (title.includes(",")) {
          return total + ((title.match(/,/g) || []).length + 1) * item.quantity;
        } else if (title.includes("Ultimate")) {
          return total + 3 * item.quantity;
        }
      } else if (type === "paddle") {
        return total + item.quantity;
      }
      return total;
    }, 0);
  }

  function getFeverQuantity(cart) {
    return cart.items.reduce((total, item) => {
      const type = item.product_type?.toLowerCase();
      const title = item.title || "";
      if (type === "paddle" && title.includes("Fever")) {
        return total + item.quantity;
      }
      return total;
    }, 0);
  }

  // Build upsell items from RAW_UPSELL_ITEMS + variantMap + cart
  function buildUpsellItems(cart) {
    const itemsInCart = cart.items.map((item) => item.variant_id);

    return RAW_UPSELL_ITEMS.map((cfg) => {
      const variantId =
        cfg.variantId ??
        (typeof cfg.resolveVariantId === "function"
          ? cfg.resolveVariantId()
          : null);
      if (!variantId) return null;
      if (itemsInCart.includes(variantId)) return null;

      const variant = getVariantById(variantId);
      if (!variant || !getAvailability(variantId)) return null;

      const price =
        cfg.price != null ? cfg.price : parseFloat(variant.price / 100);
      const compareAt =
        cfg.compareAt != null && cfg.compareAt !== 0
          ? cfg.compareAt
          : variant.compare_at_price
          ? parseFloat(variant.compare_at_price / 100)
          : null;

      return {
        variantId,
        title: cfg.title || variant.title || "",
        badge: cfg.badge || "",
        price,
        compareAt,
        buttonText: cfg.buttonText || "Add to Cart",
        image: variant.image,
      };
    }).filter(Boolean);
  }

  function buildUpsellHtml(upsellItems) {
    if (!upsellItems.length) return "";

    const cards = upsellItems.map((item) => {
      const compareHtml = item.compareAt
        ? `<span class="compare-price">$${item.compareAt.toFixed(
            2
          )}</span>`
        : "";
      const badgeHtml = item.badge
        ? `<div class="badge">${item.badge}</div>`
        : "";

      return `
        <div class="cover-card">
          <img class="thumbnail" src="${item.image}" alt="${item.title}">
          <div class="button-content">
            ${badgeHtml}
            <div class="title">${item.title}</div>
            <div class="price">
              <span class="discounted">$${item.price.toFixed(2)}</span>
              ${compareHtml}
            </div>
          </div>
          <button class="button sticky-cart-action" data-action="add" data-id="${
            item.variantId
          }">${item.buttonText}</button>
        </div>`;
    });

    const arrows =
      cards.length > 1
        ? `
      <button class="carousel-arrow left">‹</button>
      <button class="carousel-arrow right">›</button>`
        : "";

    return `
      <div class="cover-carousel-container fade">
        <div class="carousel-track">${cards.join("")}</div>
        ${arrows}
      </div>`;
  }
    // ----- Gift helpers -----

    function isGiftRuleEligible(rule, ctx) {
        const { cart, paddleQty, subtotal } = ctx;

        if (rule.minPaddles != null && paddleQty < rule.minPaddles) return false;
        if (rule.minSubtotal != null && subtotal < rule.minSubtotal) return false;

        if (rule.minQuantity && typeof rule.quantityFilter === "function") {
        const qty = cart.items.reduce((sum, item) => {
            if (
            rule.excludedVariants &&
            rule.excludedVariants.includes(item.variant_id)
            ) {
            return sum;
            }
            if (rule.quantityFilter(item)) {
            return sum + item.quantity;
            }
            return sum;
        }, 0);

        if (qty < rule.minQuantity) return false;
        }

        if (typeof rule.customEligible === "function") {
        return !!rule.customEligible(ctx);
        }

        return true;
    }

    function isGiftRuleClaimed(cart, rule) {
        if (!rule.claimedVariantIds?.length) return false;
        return cart.items.some(
        (item) =>
            rule.claimedVariantIds.includes(item.variant_id) &&
            item.discounted_price === 0
        );
    }

    function buildGiftPanelHtml(rule, giftIndex, totalAvailable) {
        const title =
        rule.title || `CLAIM GIFT ${giftIndex} OF ${totalAvailable}`;
        const options = rule.options || [];
        if (!options.length) return "";

        const defaultOption = options[0];
        const thumbsHtml = options
        .map((opt, idx) => {
            const img = getImageUrlForVariant(opt.variantId);
            if (!img) return "";
            const activeClass = idx === 0 ? "is-active" : "";
            const label = opt.label || "GIFT OPTION";
            return `
            <button
                class="gift-thumb ${activeClass}"
                data-variant-id="${opt.variantId}"
                data-label="${label}"
            >
                <img class="thumbnail" src="${img}" alt="${label}">
            </button>`;
        })
        .join("");

        const defaultLabel = defaultOption.label || "GIFT";

        return `
        <div class="gift-panel">
            <div class="gift-panel__header">
            <div class="gift-panel__title">${title}</div>
            <div class="gift-panel__underline"></div>
            </div>
            <div class="gift-panel__body">
            <div class="gift-panel__thumbnails">
                ${thumbsHtml}
            </div>
            <div class="gift-panel__details">
                <div class="gift-panel__selected-name">${defaultLabel}</div>
                <button
                class="button sticky-cart-action gift-panel__claim-btn"
                data-action="gift"
                data-id="${defaultOption.variantId}"
                >
                CLAIM GIFT
                </button>
            </div>
            </div>
        </div>
        `;
    }
  // --- Main updater ---

  function updateStickyFooter(cart) {
    currentCart = cart;

    const paddleQty = getPaddleQuantity(cart);
    const feverQty = getFeverQuantity(cart);

    const subtotalCents = cart.items.reduce(
      (sum, item) => sum + item.final_line_price,
      0
    );
    const subtotal = subtotalCents / 100;

    const originalSubtotalCents = cart.items.reduce(
      (sum, item) =>
        sum +
        (typeof item.original_line_price === "number"
          ? item.original_line_price
          : item.final_line_price),
      0
    );
    const savingsCents = Math.max(0, originalSubtotalCents - subtotalCents);
    const savings = savingsCents / 100;

    const freeShippingUnlocked = subtotal >= FREE_SHIPPING_THRESHOLD;
    const remainingForShipping = Math.max(
      0,
      FREE_SHIPPING_THRESHOLD - subtotal
    ).toFixed(2);

    // Doorbuster detection
    const hasDoorbuster = cart.items.some((item) => {
      const byId = DOORBUSTER_PRODUCT_IDS.includes(item.product_id);
      const byType =
        item.product_type &&
        item.product_type.toLowerCase().includes("doorbuster");
      const byTitle =
        item.title && item.title.toLowerCase().includes("doorbuster");
      return byId || byType || byTitle;
    });

    const doorbusterOnly = hasDoorbuster && paddleQty === 0;

    if (shippingBar) {
      shippingBar.classList.toggle("is-doorbuster", doorbusterOnly);
    }
    
     // -----------------------------
    // SHIPPING BAR
    // -----------------------------
    if (doorbusterOnly) {
      // Doorbuster mode: 2 steps — doorbuster (50%) and free ship (100%)
      const progress = freeShippingUnlocked ? 100 : 50;

      if (barFill) {
        barFill.style.width = `${progress}%`;
      }

      if (shippingBar) {
        shippingBar.setAttribute("aria-valuemin", "0");
        shippingBar.setAttribute("aria-valuemax", "100");
        shippingBar.setAttribute(
          "aria-valuenow",
          String(Math.round(progress))
        );
      }

      let barMessage;
      if (freeShippingUnlocked) {
        barMessage =
          "🔥 Doorbuster claimed + FREE SHIPPING unlocked!";
      } else {
        barMessage = `🔥 Doorbuster claimed — add $${remainingForShipping} for FREE SHIPPING`;
      }

      if (barText) {
        barText.textContent = barMessage;
      }

      const chips = document.querySelectorAll(".shipping-bar__tier");
      chips.forEach((chip) => {
        const tierNum = Number(chip.dataset.tier);
        const active = freeShippingUnlocked && tierNum === 4;
        chip.classList.toggle("active", active);
      });
    } else {
      // Normal paddle tier mode
      const maxPaddleTier = 3;
      const totalTiers = 4;

      const paddleTier = Math.min(paddleQty, maxPaddleTier);
      let visualTier = freeShippingUnlocked ? 4 : paddleTier;

      let percent;
      if (freeShippingUnlocked && paddleQty === 0) {
        percent = 0;
      } else if (visualTier <= 0) {
        percent = 0;
      } else {
        percent = (visualTier / totalTiers) * 100;
      }

      if (barFill) {
        barFill.style.width = `${percent}%`;
      }

      if (shippingBar) {
        shippingBar.setAttribute("aria-valuemin", "0");
        shippingBar.setAttribute("aria-valuemax", String(totalTiers));
        shippingBar.setAttribute("aria-valuenow", String(visualTier));
      }

      let barMessage;
      if (paddleQty <= 0) {
        barMessage = freeShippingUnlocked
          ? "You unlocked FREE SHIPPING — add a paddle to unlock 15% off"
          : "Add a paddle to unlock 15% off";
      } else if (paddleQty === 1) {
        barMessage = freeShippingUnlocked
          ? "✅ 15% OFF unlocked (plus FREE SHIPPING). Add 1 more paddle for 25% off + 2 free gifts"
          : "✅ 15% OFF unlocked — add 1 more paddle for 25% off + 2 free gifts";
      } else if (paddleQty === 2) {
        barMessage = freeShippingUnlocked
          ? "✅ 25% OFF + 2 free gifts (and FREE SHIPPING). Add 1 more paddle for 30% off + 3 free gifts"
          : "✅ 25% OFF + 2 free gifts — add 1 more paddle for 30% off + 3 free gifts";
      } else {
        if (freeShippingUnlocked) {
          barMessage =
            "🔥 30% OFF + 3 free gifts + FREE SHIPPING unlocked!";
        } else {
          barMessage = `🔥 30% OFF + 3 free gifts unlocked — add $${remainingForShipping} for FREE SHIPPING`;
        }
      }

      if (barText) {
        barText.textContent = barMessage;
      }

      const chips = document.querySelectorAll(".shipping-bar__tier");
      chips.forEach((chip) => {
        const tierNum = Number(chip.dataset.tier);
        let active = false;

        if (freeShippingUnlocked && paddleQty === 0) {
          active = tierNum === 4;
        } else {
          if (tierNum <= 3) {
            active = tierNum <= paddleTier;
          }
          if (tierNum === 4 && freeShippingUnlocked) {
            active = true;
          }
        }

        chip.classList.toggle("active", active);
      });
    }
    // -----------------------------
    // SUMMARY (TOTALS + GIFTS)
    // -----------------------------

    const realItems = cart.items.filter(
      (item) =>
        !(
          freeGiftArray.includes(item.variant_id) &&
          item.discounted_price === 0
        )
    );
    const itemCountQty = realItems.reduce((sum, item) => {
      if (item.product_id === SET_PRODUCT_ID) {
        const title = item.title || "";
        if (title.includes("/")) {
          return sum + ((title.match(/\//g) || []).length + 1) * item.quantity;
        } else if (title.includes(",")) {
          return sum + ((title.match(/,/g) || []).length + 1) * item.quantity;
        }
      }
      return sum + item.quantity;
    }, 0);

    const formattedCurrentTotal = `$${subtotal.toFixed(2)}`;
    const formattedOriginalTotal = `$${(
      originalSubtotalCents / 100
    ).toFixed(2)}`;
    const formattedSavings = `$${savings.toFixed(2)}`;

    let summaryHtml = "";

    summaryHtml += `<div class="cart-total-line">`;
    if (originalSubtotalCents > subtotalCents) {
      summaryHtml += `<span class="cart-total__current">${formattedCurrentTotal}</span> <span class="cart-total__original">${formattedOriginalTotal}</span>`;
    } else {
      summaryHtml += `<span class="cart-total__current">${formattedCurrentTotal}</span>`;
    }
    summaryHtml += `<span class="cart-meta">You're saving ${formattedSavings}</span>`;
    summaryHtml += `</div>`;

    // ----- Gift rule evaluation (for all carts, including doorbusters) -----
    const giftContext = { cart, paddleQty, subtotal };

    const ruleStates = FREE_GIFT_RULES.map((rule) => {
      const resolvedRule = { ...rule };

      if (typeof rule.resolveVariantId === "function") {
        const vid = rule.resolveVariantId();
        if (vid) {
          resolvedRule.options = (rule.options || []).map((opt) => ({
            ...opt,
            variantId: opt.variantId || vid,
          }));
          if (!resolvedRule.claimedVariantIds?.length) {
            resolvedRule.claimedVariantIds = [vid];
          }
          if (!freeGiftArray.includes(vid)) {
            freeGiftArray.push(vid);
          }
        }
      }

      const eligible = isGiftRuleEligible(resolvedRule, giftContext);
      const claimed = isGiftRuleClaimed(cart, resolvedRule);

      return { rule: resolvedRule, eligible, claimed };
    });

    const eligibleRules = ruleStates
      .filter((r) => r.eligible)
      .sort((a, b) => (a.rule.priority || 999) - (b.rule.priority || 999));

    const availableGifts = eligibleRules.length;
    const firstUnclaimed =
      eligibleRules.find((r) => !r.claimed) || null;
    const giftsClaimedCount = eligibleRules.filter((r) => r.claimed).length;

    if (availableGifts > 0) {
      summaryHtml += `<div class="cart-gifts-line">${giftsClaimedCount} of ${availableGifts} Free Gifts Claimed</div>`;
    }

    if (itemCount) {
      itemCount.innerHTML = summaryHtml;
    }

    const cartCountEl = document.querySelector(".cart-count-bubble span");
    if (cartCountEl) {
      cartCountEl.textContent = `${itemCountQty}`;
    }

    const shouldShow = shouldFooterBeVisible(cart);
    footer.classList.toggle("is-hidden", !shouldShow);

    if (itemCountQty === 0) {
      cartSummaryBtn.classList.add("disabled");
      cartSummaryBtn.setAttribute("aria-disabled", "true");
    } else {
      cartSummaryBtn.classList.remove("disabled");
      cartSummaryBtn.removeAttribute("aria-disabled");
    }

    // -----------------------------
    // GIFTS + UPSELL CTA
    // -----------------------------
    let newCtaHtml = "";
    let newAlertText = "";
    hasUnclaimedGift = false;

    const upsellItems = buildUpsellItems(cart);

    if (firstUnclaimed && availableGifts > 0) {
      hasUnclaimedGift = true;
      const giftIndex =
        eligibleRules.findIndex(
          (r) => r.rule.id === firstUnclaimed.rule.id
        ) + 1;

      newAlertText = "🎁 Free Gifts Unlocked! Claim below";
      newCtaHtml = `
        <div class="gift-cta-container fade">
          ${buildGiftPanelHtml(
            firstUnclaimed.rule,
            giftIndex,
            availableGifts
          )}
        </div>
      `;
    } else {
      hasUnclaimedGift = false;
      if (upsellItems.length) {
        newAlertText = "Add accessories to complete your setup!";
        newCtaHtml = buildUpsellHtml(upsellItems);
      } else {
        newAlertText = "";
        newCtaHtml = "";
      }
    }

    if (cta.getAttribute("data-prev-html") !== newCtaHtml) {
      cta.innerHTML = newCtaHtml;
      cta.setAttribute("data-prev-html", newCtaHtml);
      cta.classList.toggle("show", newCtaHtml !== "");
    }

    alert.textContent = newAlertText;
    alert.classList.toggle("show", newAlertText !== "");

    // Carousel arrows
    const track = cta.querySelector(".carousel-track");
    const leftBtn = cta.querySelector(".carousel-arrow.left");
    const rightBtn = cta.querySelector(".carousel-arrow.right");
    if (track && leftBtn && rightBtn) {
      const scrollAmount = 160;
      rightBtn.onclick = () => {
        const atEnd =
          Math.abs(
            track.scrollLeft + track.offsetWidth - track.scrollWidth
          ) < 5;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          track.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
      };
      leftBtn.onclick = () => {
        if (track.scrollLeft <= 0) {
          track.scrollTo({ left: track.scrollWidth, behavior: "smooth" });
        } else {
          track.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        }
      };
    }

    updateToggleLabel();
  }

  // --- CTA click handling (gift claim + upsell add) ---

  cta.addEventListener("click", (e) => {
    const btn = e.target.closest(".sticky-cart-action");
    if (!btn) return;
    const action = btn.dataset.action;
    const variantId = Number(btn.dataset.id);
    if (!variantId) return;

    btn.classList.add("loading");
    btn.disabled = true;

    if (action === "add" || action === "gift") {
      window.__blockSmartCart = true;
      window.Rebuy?.Cart?.addItem({ id: variantId, quantity: 1 });
      setTimeout(
        () => document.dispatchEvent(new Event("rebuy:cart.change")),
        800
      );
    }
  });

  window.addEventListener("resize", () => {
    updateStickyFooter(currentCart || { items: [] });
  });

  // --- Initial cart fetch + rebuy listeners ---

  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      currentCart = cart;
      updateStickyFooter(cart);
    });

  document.addEventListener("rebuy:cart.change", () => {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        currentCart = cart;
        updateStickyFooter(cart);
      });
  });

  // --- Thumbnail selection inside gift panel ---

  document.addEventListener("click", (event) => {
    const thumb = event.target.closest(".gift-thumb");
    if (!thumb) return;

    const panel = thumb.closest(".gift-panel");
    if (!panel) return;

    panel.querySelectorAll(".gift-thumb").forEach((btn) => {
      btn.classList.toggle("is-active", btn === thumb);
    });

    const label = thumb.getAttribute("data-label");
    const selectedName = panel.querySelector(".gift-panel__selected-name");
    if (selectedName && label) {
      selectedName.textContent = label;
    }

    const variantId = thumb.getAttribute("data-variant-id");
    const claimBtn = panel.querySelector(".gift-panel__claim-btn");
    if (claimBtn && variantId) {
      claimBtn.setAttribute("data-id", variantId);
    }
  });

  // --- See Cart click → open SmartCart ---

  viewCartMain?.addEventListener("click", (e) => {
    const disabled = viewCartMain
      .querySelector("#cartSummary")
      ?.classList.contains("disabled");
    if (disabled) {
      e.preventDefault();
      return;
    }
    window.__blockSmartCart = false;
    window.Rebuy?.SmartCart?.show?.();
  });

  // Initialize toggle label before cart loads
  updateToggleLabel();
});
